import {Algorithm} from "./Algorithm";
import {UserInputSliderSelector} from "./UserInputSliderSelector";

export class Hydra extends Algorithm {

  constructor(container) {
    super(container);

    this.weatherOverrides = {
      value: {
        10: "snowing",
        25: "stormy",
        50: "foggy",
        75: "cloudy",
        100: "sunny",
      }
    };
  }

  buildRangesMap() {
    this.rangesMap = this.userCombinationData.map(({key, title}, index) => {
      const value = parseInt(title);
      return {key, value, index};
    });
  }

  initUserInputs() {
    super.initUserInputs();

    this.occupancyLevelSelector = new UserInputSliderSelector(
      this.$container.find(`.user-input-selector-container[data-user-input-id="occupancy_level"]`),
      this.rangesMap.map(r => r.value)
    );
    this.occupancyLevelSelector.on("userInputValueChanged", (value) => this.onUserInput(value));
  }

  onUserInput(value) {
    const targetCombination = this.findUserCombination(value);

    // Update KPIs
    this.selectKPIs(targetCombination.key);

    // Update charts
    Object.entries(this.charts).forEach(([name, chart]) => {
      chart.loadDataset(targetCombination.index);
    });

    this.decisionLogs.update(this.currentKPIKey, this.buildingSelector.currentBuilding);

    this.sendWeatherOverride();
  }

  sendWeatherOverride() {
    if (!this.isActive) return;

    const targetCombination = this.findUserCombination(this.occupancyLevelSelector.currentValue);

    app.sendScreenBridgeMessage(`weatherOverride ${this.weatherOverrides.value[targetCombination.value] ?? "none"}`);
  }

  start() {
    super.start();

    this.sendWeatherOverride();
  }

  findUserCombination(value) {
    // Let's return the entry where the value fits in the correct range
    // reduce walks the array keeping track of whichever entry has the smallest distance to the input value.
    // No need for a fallback since it always returns something.
    return this.rangesMap.reduce((closest, entry) =>
      Math.abs(entry.value - value) < Math.abs(closest.value - value) ? entry : closest
    );
  }

  onBuildingChange(type) {
    super.onBuildingChange(type);

    // Dummy equipment - Set related equipment state based on type
    if (type === "officetower") {
      app.sendScreenBridgeMessage(`updateEquipmentsState CHILLER_01 cooling`);
    } else {
      this.updateAllBuildingsEquipments("active");
    }
  }

  resetUserInputs() {
    this.occupancyLevelSelector.reset();
  }

}
